import styled from 'styled-components';

import { mediaWide, mediaConfined } from '@xing-com/layout-tokens';
import {
  spaceXXL,
  spaceL,
  spaceXL,
  spaceXS,
  xdlColorBackgroundSecondary,
  cornerRadiusL,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const Container = styled.div`
  padding: ${spaceXL} 0;
  margin-bottom: ${spaceXL};
  border-radius: ${cornerRadiusL};

  @media ${mediaWide} {
    padding-left: ${spaceXXL};
    padding-right: ${spaceXXL};
    margin-bottom: 0;
    background-color: ${xdlColorBackgroundSecondary};
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }

  @media ${mediaWide} {
    margin-bottom: ${spaceL};
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${spaceL};
  background-color: ${xdlColorBackgroundSecondary};
  border-radius: ${cornerRadiusL};

  @media ${mediaWide} {
    padding: 0;
    background-color: transparent;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  padding: 0 ${spaceXS};
  margin: ${spaceXS} 0;
  width: 100%;

  @media ${mediaConfined} {
    padding: 0;
    width: 50%;
  }

  @media ${mediaWide} {
    width: 100%;
  }
`;
